export enum ResearchType {
  ReportProfile = 'reportProfile',
  ManagementQuestions = 'MgmtQs',
  AnalystNote = 'analystNote',
}
